import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Eye, Trash2 } from 'lucide-react';
import Swal from 'sweetalert2';
import { useSelector } from 'react-redux';

const CampaignsPage = () => {
  const [adAccounts, setAdAccounts] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [campaigns, setCampaigns] = useState([]);
  const [previewCampaign, setPreviewCampaign] = useState(null);
  const userdata = useSelector((store) => store.userReducer.userdata);

  useEffect(() => {
    const fetchAdAccounts = async () => {
      try {
        const res = await axios.get(
          `https://graph.facebook.com/v19.0/${userdata.business_id}/owned_ad_accounts?access_token=${userdata.metatoken}`
        );
        setAdAccounts(res.data.data);
      } catch (err) {
        console.error('Failed to fetch ad accounts', err);
      }
    };

    if (userdata?.metatoken && userdata?.business_id) {
      fetchAdAccounts();
    }
  }, [userdata]);

  const handleAccountChange = async (adAccountId) => {
    const account = adAccounts.find(
      (a) => a.id === adAccountId || a.id === `act_${adAccountId}`
    );
    if (!account) return;

    setSelectedAccount(account);

    const adAccountIdWithPrefix = account.id.startsWith('act_')
      ? account.id
      : `act_${account.id}`;

    console.log("Fetching campaigns for:", adAccountIdWithPrefix);

    try {
      const res = await axios.get(
        `https://graph.facebook.com/v19.0/${adAccountIdWithPrefix}/campaigns?fields=name,status,effective_status,start_time,stop_time,daily_budget,objective&access_token=${userdata.metatoken}`
      );
      setCampaigns(res.data.data);
    } catch (err) {
      console.error('Failed to fetch campaigns', err.response?.data || err.message);
    }
  };

  // const handleDeleteCampaign = async (campaignId) => {
  //   try {
  //     await axios.delete(
  //       `https://graph.facebook.com/v19.0/${campaignId}?access_token=${userdata.metatoken}`
  //     );
  //     setCampaigns((prev) => prev.filter((c) => c.id !== campaignId));
  //     Swal.fire('Deleted!', 'Campaign has been deleted.', 'success');
  //   } catch (err) {
  //     console.error('Failed to delete campaign', err);
  //     Swal.fire('Error', 'Failed to delete campaign', 'error');
  //   }
  // };

  // const confirmDelete = (campaignId) => {
  //   Swal.fire({
  //     title: 'Are you sure?',
  //     text: 'This will permanently delete the campaign.',
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonColor: '#d33',
  //     cancelButtonColor: '#3085d6',
  //     confirmButtonText: 'Yes, delete it!',
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       handleDeleteCampaign(campaignId);
  //     }
  //   });
  // };

  return (
    <section className="posts-section">
      <div className="posts-header">
        <h2>Facebook Campaigns</h2>
        <select onChange={(e) => handleAccountChange(e.target.value)} defaultValue="">
          <option value="" disabled>Select Ad Account</option>
          {adAccounts.map((acc) => (
            <option
              key={acc.id}
              value={acc.id.replace('act_', '')}
            >
              {acc.name || acc.id}
            </option>
          ))}
        </select>
      </div>

      {campaigns.length === 0 && selectedAccount && (
        <p style={{ textAlign: 'center', marginTop: '1rem' }}>
          No campaigns found in this account.
        </p>
      )}

      <ul className="posts-list">
        {campaigns.map((campaign) => (
          <li key={campaign.id} className="post-card">
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div>
                <h3>{campaign.name}</h3>
                <p className="post-date">
                  {campaign.start_time ? new Date(campaign.start_time).toLocaleDateString() : 'N/A'}
                  {" - "}
                  {campaign.stop_time ? new Date(campaign.stop_time).toLocaleDateString() : 'Ongoing'}
                </p>
              </div>
              {/* <button className="delete-post-btn" onClick={() => confirmDelete(campaign.id)}>
                <Trash2 size={16} /> Delete
              </button> */}
            </div>

            <div className="post-stats-grid">
              <div className="stat-box">
                <strong>Status:</strong> <span>{campaign.status}</span>
              </div>
              <div className="stat-box">
                <strong>Effective:</strong> <span>{campaign.effective_status}</span>
              </div>
              <div className="stat-box">
                <strong>Objective:</strong> <span>{campaign.objective || '—'}</span>
              </div>
              <div className="stat-box">
                <strong>Budget:</strong>{' '}
                <span>{campaign.daily_budget ? `₹${campaign.daily_budget / 100}` : 'N/A'}</span>
              </div>
            </div>
          </li>
        ))}
      </ul>

      {previewCampaign && (
        <div className="image-modal" onClick={() => setPreviewCampaign(null)}>
          <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>{previewCampaign.name}</h3>
            <p>ID: {previewCampaign.id}</p>
            <button className="close-btn" onClick={() => setPreviewCampaign(null)}>Close</button>
          </div>
        </div>
      )}
    </section>
  );
};

export default CampaignsPage;
